import { useCallback, useEffect, useState } from "react";
import { listAccounts, listBoxes, listContacts } from "../../api/accounting";
import { listBranches, listUsers } from "../../api/directory";

// Shared lookups for the operational accounting screens (يتضمّن الفروع والموظفين).
export const useAcctLookups = () => {
  const [state, setState] = useState({ accounts: [], boxes: [], suppliers: [], customers: [], branches: [], employees: [] });

  const load = useCallback(async () => {
    const [accounts, boxes, suppliers, customers, branches, employees] = await Promise.all([
      listAccounts(),
      listBoxes(),
      listContacts({ kind: "supplier" }),
      listContacts({ kind: "customer" }),
      listBranches().catch(() => []),
      listUsers().catch(() => []),
    ]);
    setState({
      accounts: accounts.filter((a) => a.is_leaf && a.active !== false),
      boxes, suppliers, customers, branches,
      employees: (employees || []).filter((u) => u.active !== false && u.status !== "inactive"),
    });
  }, []);

  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load };
};
